import * as commander from "commander";
import container from "./inversify.config";
import TYPES from "./TYPES";
import { ConsoleUI } from "./utils/ConsoleUI";
import { AuthenticationServer } from "./signup/AuthenticationServer";
import { KotennaApi } from "./lib/kotenna/KotennaApi";
import { ServiceConfiguration } from "./utils/ServiceConfiguration";
import { AppDeployer } from "./apps/AppDeployer";

commander
    .command("do-wordpress")
    .description("Deploy a standard wordpress site in DigitalOcean")
    .action(async (cmd, options) => {

        const worker = container.get<AppDeployer>(TYPES.AppDigitalOceanWordpress);

        worker.run()
            .then(success => {
                console.log(success);
            })
            .catch(error => {
                console.log(error.message);
                process.exit(501);
            });

    });


commander.parse(process.argv);

if (!commander.args.length) {
    commander.help();
}